<template>
<div class="qa-page-wrap">
  <div class="qaWrap">
    <!-- <div class="qa01">
      <div class="link-wrap" @click="jumpDiscord"></div>
    </div> -->
    <h2>
      <span>{{$t('upgrade_page_views_static_qa_index_2263')}}</span>
      <span>Q&A</span>
    </h2>
    <h3>{{$t('upgrade_page_views_static_qa_index_2264')}}</h3>
    <div class="step-wrap">
      <div class="step-item">
        <h4>{{$t('upgrade_page_layout_header_9')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2265')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2266')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2267')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2268')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2269')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2270')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2271')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2272')}}</p>
      </div>
      <div class="step-item margin65">
        <h4>{{$t('upgrade_page_views_static_qa_index_2273')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2274')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2275')}}</p>
      </div>
      <div class="step-item margin65">
        <h4>{{$t('upgrade_page_views_static_qa_index_2276')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2277')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2278')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2279')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2280')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2281')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2282')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_views_withdrawalbenfit_withdrawatm_1622')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2283')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2284')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2285')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2286')}}</p>
      </div>
      <div class="step-item margin65">
        <h4>{{$t('upgrade_page_layout_header_20')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2287')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2288')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2289')}}</h5>
        <div class="to-person">
          <h3>{{$t('upgrade_page_views_static_qa_index_2290')}}</h3>
          <ul>
            <li>{{$t('upgrade_page_views_static_qa_index_2291')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2292')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2293')}}</li>
          </ul>
        </div>
        <div class="to-person">
          <h3>{{$t('upgrade_page_views_static_qa_index_2294')}}</h3>
          <ul>
            <li>{{$t('upgrade_page_views_static_qa_index_2295')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2296')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2293')}}</li>
          </ul>
        </div>
        <h5>{{$t('upgrade_page_views_static_qa_index_2297')}}</h5>
      <p>{{$t('upgrade_page_views_static_qa_index_2298')}}</p>
      </div>
      <div class="step-item margin65">
        <h4>{{$t('upgrade_page_views_static_qa_index_2299')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2300')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2301')}}</p>
      </div>
      <div class="step-item margin65">
        <h4>{{$t('upgrade_page_views_static_qa_index_2302')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2303')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2304')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2305')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2306')}}</p>
      </div>
      <div class="step-item margin65">
        <h4>{{$t('components_recharge_index_389')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2307')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2308')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2309')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2310')}}</p>
      </div>
    </div>
    <p>{{$t('upgrade_page_views_static_qa_index_2311')}}</p>
  </div>
  <div class="qaWarp-moblie">
    <!-- <div class="qa01">
      <div class="link-wrap" @click="jumpDiscord"></div>
    </div> -->
    <h2>
      <span>{{$t('upgrade_page_views_static_qa_index_2263')}}</span>
      <span>Q&A</span>
    </h2>
    <h3>{{$t('upgrade_page_views_static_qa_index_2264')}}</h3>
    <div class="step-wrap">
      <div class="step-item">
        <h4>{{$t('upgrade_page_layout_header_9')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2265')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2266')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2267')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2268')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2269')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2270')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2271')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2272')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_views_static_qa_index_2273')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2274')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2275')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_views_static_qa_index_2276')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2277')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2278')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2279')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2280')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2281')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2282')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_views_withdrawalbenfit_withdrawatm_1622')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2283')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2284')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2285')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2286')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_layout_header_20')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2287')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2288')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2289')}}</h5>
        <div class="to-person">
          <h3>{{$t('upgrade_page_views_static_qa_index_2290')}}</h3>
          <ul>
            <li>{{$t('upgrade_page_views_static_qa_index_2291')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2292')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2293')}}</li>
          </ul>
        </div>
        <div class="to-person">
          <h3>{{$t('upgrade_page_views_static_qa_index_2294')}}</h3>
          <ul>
            <li>{{$t('upgrade_page_views_static_qa_index_2295')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2296')}}</li>
            <li>{{$t('upgrade_page_views_static_qa_index_2293')}}</li>
          </ul>
        </div>
        <h5>{{$t('upgrade_page_views_static_qa_index_2297')}}</h5>
      <p>{{$t('upgrade_page_views_static_qa_index_2298')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_views_static_qa_index_2299')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2300')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2301')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('upgrade_page_views_static_qa_index_2302')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2303')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2304')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2305')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2306')}}</p>
      </div>
      <div class="step-item margin45">
        <h4>{{$t('components_recharge_index_389')}}</h4>
        <h5>{{$t('upgrade_page_views_static_qa_index_2307')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2308')}}</p>
        <h5>{{$t('upgrade_page_views_static_qa_index_2309')}}</h5>
        <p>{{$t('upgrade_page_views_static_qa_index_2310')}}</p>
      </div>
    </div>
    <p>{{$t('upgrade_page_views_static_qa_index_2311')}}</p>
  </div>
</div>

</template>

<script>
export default {
  methods: {
    jumpDiscord() {
      window.open('https://discord.gg/mQXuq5e')
    }
  }
}
</script>

<style lang="scss" scoped>
.margin65{
  margin-top: 65px;
}
.margin45{
  margin-top: 45px;
}
.to-person{
  margin-top: 10px;
  h3{
    font-weight: 500;
    text-indent: 1px;
    font-feature-settings: 'liga' off;
    color: #333333;
  }
  li{
    text-indent: 1px;
    font-feature-settings: 'liga' off;
    color: #666666;
    list-style-type: disc;
    word-break: break-all;
  }
}
.step-wrap{
  background: #ffffff;
  border-radius: 20px;
}
.step-item{
  >h4{
    margin-top: 0;
    font-weight: 600;
    color: #333333;
  }
  h5{
    font-weight: 500;
    color: #333333;
  }
  p{
    margin-top: 10px;
    color: #666666;
    word-break: break-all;
  }
}
@media screen and (min-width:600px) {
  .to-person{
    margin-top: 10px;
    h3{
      font-size: 18px;
      line-height: 25px;
    }
    li{
      margin-top: 15px;
      font-size: 18px;
      line-height: 25px;
      margin-left: 40px;
    }
    li:nth-of-type(1){
      margin-top: 10px;
    }
  }
  .step-item{
    h5:nth-of-type(1){
      margin-top: 40px;
    }
    >h4{
      font-size: 32px;
      line-height: 45px;
    }
    h5{
      margin-top: 45px;
      font-size: 24px;
      line-height: 34px;
    }
    p{
      font-size: 18px;
      line-height: 25px;
    }
  }
  .step-wrap{
    margin: 100px 20px 0;
    padding: 40px 40px 90px;
    border: 10px solid #333333;
  }
  .qaWrap {
    height: 3967px;
    background: url('./qaImages/qaPC.png') no-repeat center;
    background-size: 100%;
    margin: 40px auto;
    line-height: 0;
    display: flex;
    flex-direction: column;
    >h2{
      text-align: center;
      margin-top: 100px;
      span{
        font-style: normal;
        font-weight: bold;
        font-size: 72px;
        line-height: 101px;
        color: #FE7F38;
      }
      span:nth-of-type(2){
        margin-left: 25px;
      }
    }
    >h3{
      text-align: center;
      margin-top: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 42px;
      line-height: 59px;
      color: #000000;
    }
    >p{
      margin-top: 100px;
      text-align: center;
      font-weight: bold;
      font-size: 42px;
      line-height: 59px;
      color: #333333;
    }
    .qa01 {
      width:100%;
      position: relative;
    }
    .link-wrap {
      width: 300px;
      height: 20px;
      position: absolute;
      top: 670px;
      left: 700px;
      cursor: pointer;
    }
  }
  .qaWarp-moblie {
    display: none;
  }
}
@media screen and (max-width:599px) {
  .to-person{
    margin-top: 10px;
    h3{
      font-size: 14px;
      line-height: 20px;
    }
    li{
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      margin-left: 16px;
    }
  }
  .step-item{
    >h4{
      font-size: 24px;
      line-height: 34px;
    }
    h5{
      margin-top: 25px;
      font-size: 18px;
      line-height: 25px;
    }
    p{
      font-size: 14px;
      line-height: 20px;
    }
  }
  .step-wrap{
    margin: 50px 18px 0;
    padding: 27px 17px 37px;
    border: 3px solid #333333;
  }
  .qaWrap {
    display: none;
  }
  .qa-page-wrap{
    margin-bottom: 52px!important;
  }
  .qaWarp-moblie {
    width: 100vw;
    height: 3350px;
    line-height: 0;
    display: flex;
    flex-direction: column;
    background: url('./qaImages/qaMobile.png') no-repeat center;
    background-size: 100%;
    .qa01 {
      position: relative;
      .link-wrap {
        width: 300px;
        height: 20px;
        position: absolute;
        top: 56%;
        left: 40px;
        cursor: pointer;
      }
    }
    >h2{
      text-align: center;
      margin-top: 50px;
      span{
        font-style: normal;
        font-weight: bold;
        font-size: 28px;
        line-height: 39px;
        color: #FE7F38;
      }
      span:nth-of-type(2){
        margin-left: 8px;
      }
    }
    >h3{
      text-align: center;
      margin-top: 6px;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      color: #000000;
    }
    >p{
      margin-top: 50px;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      line-height: 25px;
      color: #333333;
    }
  }
}
</style>
